import type { ChangeEvent, FC } from 'react';

type CheckboxPropTypes = {
  label?: string;
  name: string;
  id?: string;
  onChange?: (value: ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
};

const Checkbox: FC<CheckboxPropTypes> = ({ checked, name, id, label, onChange }) => {
  return (
    <div className="flex items-center gap-2">
      <div className="w-[18px] h-[18px] flex items-center justify-center">
        <input
          onChange={onChange}
          checked={checked}
          name={id || name}
          id={id || name}
          type="checkbox"
          className="appearance-none flex-shrink-0 checked:bg-checked-icon w-[13.5px] h-[13.5px] bg-center bg-no-repeat bg-contain checked:border-none rounded-[1px] border-base-gray-800 border-2 cursor-pointer hover:bg-base-blue-100/10"
        />
      </div>

      <label
        className="text-[13px] md:text-sm font-normal text-black leading-4 md:leading-5"
        htmlFor={id || name}
      >
        {label}
      </label>
    </div>
  );
};

export { Checkbox };
